/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 注册会员PC端
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  memberRegisterPCDto: member.MemberRegisterPCDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.CuUser;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/member/pc`,
    data: memberRegisterPCDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
